(function ($) {
  Drupal.behaviors.toutsFormatterV1 = {
    attach: function (context) {
      var $thisFormatter = $('.js-touts-formatter-v1', context);
      var $animateElements = $('.touts-formatter__tout', context);
      var rowIsAnmimated = $thisFormatter.parents('.homepage-formatter__row').length;

      $('.js-touts-formatter-v1[data-first-tout-push-down]', context).once().each(function () {
        var $toutWrapper = $(this);
        var $toutsTitle = $toutWrapper.find('.touts-formatter__title');
        var $toutsFirstTout = $toutWrapper.find('.touts-formatter__tout:first-child');

        $toutsTitle.prependTo($toutsFirstTout);
      });

      if (rowIsAnmimated > 0) {
        $animateElements.each(function () {
          var $animateElement = $(this);

          $animateElement.waypoint({
            handler: function (direction) {
              $animateElements.show();
              $animateElement.toggleClass('come-in', direction === 'down');
            },
            offset: '93%'
          });
        });
      }
    }
  };
})(jQuery);
